import { TextField, Divider } from "@mui/material";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import InputAdornment from "@mui/material/InputAdornment";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import Modal from "../../UI/Modal";
import Contragenty from "../../spravochniki/contragent/Contragenty";
import { useCreateDogovorMutation } from "../../../store/dogovorApi";
import Raschety from "../raschet/Raschety";
import { generatePaymentSchedule } from "../../../utilits/helpers/generatePaymentSchedule";
import { convertToInputDate } from "../../../utilits/helpers/convertDateFormat";
import { useSelector } from "react-redux";

export default function CreateDogovor({ onClose }) {
  const { id } = useSelector((state) => state.auth);
  const [addData] = useCreateDogovorMutation();
  const [docDate, setDocDate] = React.useState(convertToInputDate(new Date()));
  const [numberDogovor, setNumberDogovor] = React.useState("");
  const [protocol, setProtocol] = React.useState("");
  const [dateDogovorFrom, setDateDogovorFrom] = React.useState("");
  const [dateDogovorTo, setDateDogovorTo] = React.useState("");
  const [contragent, setContragent] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [coordinates, setCoordinates] = React.useState("");
  const [nomenklatura, setNomenklatura] = React.useState("");
  const [inn, setInn] = React.useState("");
  const [nalog, setNalog] = React.useState("");
  const [totalSum, setTotalSum] = React.useState("");
  const [identCode, setIdentCode] = React.useState("");
  const [square, setSquare] = React.useState("");
  const [purpose, setPurpose] = React.useState("");
  const [modalForContragenty, setModalForContragenty] = React.useState(false);
  const [modalForRaschty, setModalForRaschety] = React.useState(false);
  const [contragentID, setContragentID] = React.useState("");
  const [nomenklaturaID, setNomenklaturaID] = React.useState("");
  const [invoice, setInvoice] = React.useState("");

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const getContragentItem = (item) => {
    setContragent(
      item.attributes.surname +
        " " +
        item.attributes.name +
        " " +
        item.attributes.lastname
    );
    setInn(item.attributes.inn);
    setContragentID(item.id);
  };

  const getRaschetItem = (item) => {
    setNomenklatura(item.attributes.nomenklatura.data[0].attributes.name);
    setIdentCode(item.attributes.nomenklatura.data[0].attributes.inventNumber);
    setSquare(item.attributes.nomenklatura.data[0].attributes.square);
    setAddress(
      item.attributes.nomenklatura.data[0].attributes.address +
        " " +
        item.attributes.nomenklatura.data[0].attributes.addressNumber
    );
    setCoordinates(item.attributes.nomenklatura.data[0].attributes.coordinates);
    setNomenklaturaID(item.attributes.nomenklatura.data[0].id);
    setTotalSum(item.attributes.sum);
    setNalog(item.attributes.nalog);
  };
  const paymentSchedule = JSON.stringify(
    generatePaymentSchedule(
      new Date(dateDogovorFrom),
      new Date(dateDogovorTo),
      totalSum
    )
  );
  const nalogSchedule = JSON.stringify(
    generatePaymentSchedule(
      new Date(dateDogovorFrom),
      new Date(dateDogovorTo),
      nalog
    )
  );

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    const newData = {
      docDate,
      numberDogovor,
      protocol,
      dateDogovorFrom,
      dateDogovorTo,
      totalSum,
      nalog,
      contragent: contragentID,
      nomenklatura: nomenklaturaID,
      user: id,
      invoice,
      schedule: paymentSchedule,
      scheduleNalog: nalogSchedule,
      purpose,
    };
    addData(newData);
    console.log(newData);
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfCreation>Добавить новый договор</TitleOfCreation>
      <BlockStyled margin="0 0 20px 0" width="100%">
        <BlockStyled width="100%" display="flex" justifyContent="space-between">
          <TextFieldStylded
            id="date"
            type="date"
            InputLabelProps={{ shrink: true }}
            label="Дата документа"
            variant="outlined"
            value={docDate}
            onChange={(event) => inputChangeHandler(event, setDocDate)}
            size="small"
            width="150px"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="№ договора"
            variant="outlined"
            value={numberDogovor}
            onChange={(event) => inputChangeHandler(event, setNumberDogovor)}
            size="small"
            width="5vw"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="На основании"
            variant="outlined"
            value={protocol}
            onChange={(event) => inputChangeHandler(event, setProtocol)}
            width="20vw"
            size="small"
          />

          <BlockStyled
            display="flex"
            justifyContent="center"
            alignItems="center"
            margin="0 10px"
            width="10px"
          >
            с
          </BlockStyled>
          <TextFieldStylded
            id="date"
            type="date"
            InputLabelProps={{ shrink: true }}
            label="Сроки договора"
            variang="outlined"
            value={dateDogovorFrom}
            onChange={(event) => inputChangeHandler(event, setDateDogovorFrom)}
            size="small"
            width="150px"
          />
          <BlockStyled
            display="flex"
            justifyContent="center"
            alignItems="center"
            margin="0 10px"
            width="10px"
          >
            по
          </BlockStyled>
          <TextFieldStylded
            id="date"
            type="date"
            InputLabelProps={{ shrink: true }}
            label="Сроки договора"
            variant="outlined"
            value={dateDogovorTo}
            onChange={(event) => inputChangeHandler(event, setDateDogovorTo)}
            width="150px"
            size="small"
          />
        </BlockStyled>
        <BlockStyled
          width="100%"
          margin="20px 0 0 0"
          display="flex"
          justifyContent="space-between"
        >
          <TextFieldStylded
            InputLabelProps={{ shrink: true }}
            label="Контрагент"
            id="outlined-end-adornment"
            size="small"
            width="35%"
            value={contragent}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconStyled
                    onClick={() => setModalForContragenty(true)}
                    color="primary"
                  />
                </InputAdornment>
              ),
            }}
          />
          <Modal
            fullwidth={"60%"}
            isOpen={modalForContragenty}
            onClose={() => setModalForContragenty(false)}
          >
            <Contragenty
              onCloseContragenty={() => setModalForContragenty(false)}
              getContragentItem={getContragentItem}
            />
          </Modal>
          <TextFieldStylded
            id="outlined-basic"
            label="ИНН"
            variant="outlined"
            value={inn}
            onChange={(event) => inputChangeHandler(event, setInn)}
            size="small"
            width="15%"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Сумма налога"
            variant="outlined"
            value={nalog}
            onChange={(event) => inputChangeHandler(event, setNalog)}
            size="small"
            width="12%"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Сумма"
            variant="outlined"
            value={totalSum}
            onChange={(event) => inputChangeHandler(event, setTotalSum)}
            size="small"
            width="12%"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Лицевой счет"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            variant="outlined"
            value={invoice}
            onChange={(event) => inputChangeHandler(event, setInvoice)}
            size="small"
            width="15%"
            disabled
          />
        </BlockStyled>
      </BlockStyled>
      <DividerStyled light margin="30px 0" />
      <BlockStyled
        margin="20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          label="Номеклатура из расчета"
          id="outlined-end-adornment"
          mrg="0 20px 0 0"
          width="25%"
          value={nomenklatura}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconStyled
                  onClick={() => setModalForRaschety(true)}
                  color="primary"
                />
              </InputAdornment>
            ),
          }}
        />
        <Modal
          fullwidth={"60%"}
          isOpen={modalForRaschty}
          onClose={() => setModalForRaschety(false)}
        >
          <Raschety
            onCloseRaschety={() => setModalForRaschety(false)}
            getRaschetItem={getRaschetItem}
            checkBusy={false}
          />
        </Modal>

        <TextFieldStylded
          id="outlined-basic"
          label="Идентификационный код"
          value={identCode}
          onChange={(event) => inputChangeHandler(event, setIdentCode)}
          width="25%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Площадь"
          variant="outlined"
          value={square}
          onChange={(event) => inputChangeHandler(event, setSquare)}
          width="10%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Целевое назначение"
          variant="outlined"
          value={purpose}
          onChange={(event) => inputChangeHandler(event, setPurpose)}
          width="35%"
        />
      </BlockStyled>
      <BlockStyled
        width="100%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Расположенный по адресу"
          variant="outlined"
          value={address}
          onChange={(event) => inputChangeHandler(event, setAddress)}
          width="50%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Координаты"
          variant="outlined"
          value={coordinates}
          onChange={(event) => inputChangeHandler(event, setCoordinates)}
          width="45%"
        />
      </BlockStyled>

      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        ></BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const DividerStyled = styled(Divider)`
  margin: ${(props) => props.margin};
`;
const IconStyled = styled(MoreHorizTwoToneIcon)`
  cursor: pointer;
`;
const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfCreation = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
